import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import cross from '../../../../assets/messageStatuses/Cross.png';
import DepartmentsSelector from '../../../Chat/common/DepartmentsSelector';
import { MyInput } from '../../../Base/Form';
import styles from './Filters.module.scss';
const Filters = ({ search, onSearchChanged, department, onDepartmentChanged, loading }) => {
    const { i18n } = useTranslation();
    const replyRef = useRef(null);
    const onDepartmentHandler = (value) => {
        if (value === 'allDepartments') {
            onDepartmentChanged('');
        }
        else {
            onDepartmentChanged(value);
        }
    };
    return (React.createElement("div", { className: styles.filtersWrapper },
        React.createElement("div", { className: styles.search },
            React.createElement(MyInput, { value: search, onChangeHandler: onSearchChanged, type: "search", size: "middle", forwardRef: replyRef, className: styles.input, placeholder: i18n.t('searchQuickReplies'), bordered: false, loading: loading, allowClear: {
                    clearIcon: (React.createElement("img", { className: styles.cleanSearchInput, src: cross, onClick: () => {
                            var _a;
                            onSearchChanged('');
                            (_a = replyRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                        } })),
                } })),
        React.createElement(DepartmentsSelector, { onChange: onDepartmentHandler, value: department || 'allDepartments', style: styles.depFilter, size: "middle" })));
};
export default Filters;
